<template>
  <BaseWrapper :loading="loading">
    <div class="space-y-4">
      <BaseCard title="Tambah Pengeluaran Grup">
        <SearchOfficeInput v-model="form.office" @change="loadOfficeOrderDetails" />
      </BaseCard>
      <BaseCard title="Daftar Barang">
        <Datatable
          :columns="productColumns"
        >
          <template #tbody="{ classes }">
            <tbody v-if="products.length">
              <template v-for="(product, index) in products">
                <tr :key="product.product_id" :class="[index !== products.length - 1 || productOrderDetailsVisible[product.product_id] ? 'border-b' : '']">
                  <td :class="classes.td">{{ product.product_code }}</td>
                  <td :class="classes.td">{{ product.stock_qty | toCurrency }}</td>
                  <td :class="classes.td">{{ product.free_qty | toCurrency }}</td>
                  <td :class="classes.td">
                    <p v-if="product.reimbursement_qty > 0">{{ countShipped(product.product_id, 'reimbursement') | toCurrency }} / {{ product.reimbursement_qty | toCurrency }}</p>
                    <p v-else>-</p>
                  </td>
                  <td :class="classes.td">
                    <p v-if="product.free_follow_up_qty > 0">{{ countShipped(product.product_id, 'follow-up') | toCurrency }} / {{ product.free_follow_up_qty | toCurrency }}</p>
                    <p v-else>-</p>
                  </td>
                  <td :class="classes.td">
                    <button @click="onOpenOrderDetails(product.product_id)">
                      <Icon v-if="!productOrderDetailsVisible[product.product_id]" class="h-5 w-5" icon="heroicons:chevron-right-20-solid" />
                      <Icon v-else class="h-5 w-5" icon="heroicons:chevron-down-20-solid" />
                    </button>
                  </td>
                </tr>

                <template v-if="productOrderDetailsVisible[product.product_id]">
                  <tr v-for="(orderDetail, index) in productOrderDetails[product.product_id]" :key="`${product.product_id}-${orderDetail.id}`" class="bg-gray-50">
                    <td :class="[classes.td, 'pl-10']">
                      {{ orderDetail.code }}
                    </td>
                    <td :class="classes.td">{{ orderDetail.createdAt | formatDate }}</td>
                    <td :class="classes.td"></td>
                    <td :class="classes.td">
                      <div class="flex items-center gap-2">
                        <template v-if="orderDetail.reimbursementQty">
                          <BaseInput currency type="text" :shadow="false" placeholder="0" v-model="productOrderDetails[product.product_id][index].shipReimbursementQty" @change="onChangeOrderDetailQty(product.product_id, index, 'reimbursement')" />
                          <p>/</p>
                          <p>{{ orderDetail.reimbursementQty | toCurrency }}</p>
                        </template>
                        <p v-else>-</p>
                      </div>
                    </td>
                    <td :class="classes.td">
                      <div class="flex items-center gap-2">
                        <template v-if="orderDetail.followUpQty">
                          <BaseInput size="sm" currency type="text" :shadow="false" placeholder="0" v-model="productOrderDetails[product.product_id][index].shipFollowUpQty" @change="onChangeOrderDetailQty(product.product_id, index, 'follow-up')" />
                          <p>/</p>
                          <p>{{ orderDetail.followUpQty | toCurrency }}</p>
                        </template>
                        <p v-else>-</p>
                      </div>
                    </td>
                    <td></td>
                  </tr>
                </template>
              </template>
            </tbody>
          </template>
        </Datatable>
      </BaseCard>

      <div class="flex justify-end gap-2">
        <BaseButton :disabled="emptyShipQty" @click="confirmVisible = true">Simpan</BaseButton>
        <BaseButton color="white" :to="{ name: 'gudang.reimbursement-group.index' }">Kembali</BaseButton>
      </div>
    </div>

    <BaseConfirm
      :visible="confirmVisible"
      icon-type="badge"
      title="Konfirmasi Pengeluaran Grup"
      message="Jumlah per faktur akan dikurangi, lanjutkan?"
      type="success"
      @confirmed="onSave"
      @close="confirmVisible = false"
    />
  </BaseWrapper>
</template>

<script>
import { mapActions } from 'vuex';
import BaseConfirm from '../../../../../components/base/BaseConfirm.vue';
import SearchOfficeInput from '../../../../../components/office/search-office-input.vue';
import { requestMixin } from '../../../../../mixins/request/request';
import { sum } from '../../../../../utils/array.js';

export default {
  mixins: [requestMixin],
  components: {
    SearchOfficeInput,
    BaseConfirm
  },
  data() {
    return {
      loading: false,
      form: {
        office: {
          id: null,
          code: null,
          searchCode: null,
          originalCode: null,
          name: null,
        },
      },
      products: [],
      productOrderDetailsVisible: {},
      productOrderDetails: {},
      confirmVisible: false
    }
  },
  computed: {
    productColumns() {
      return [
        { id: 'product_code', name: 'Kode Produk' },
        { id: 'stock_regular', name: 'Stok Reguler' },
        { id: 'stock_free', name: 'Stok Promo' },
        { id: 'regular_qty', name: 'Reguler' },
        { id: 'free_qty', name: 'Promo' },
        { id: 'action', name: 'Aksi' }
      ]
    },
    emptyShipQty() {
      return !this.products.some(product => this.countShipped(product.product_id, 'reimbursement') > 0 || this.countShipped(product.product_id, 'follow-up') > 0)
    }
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert'
    }),
    countShipped(productId, type) {
      return sum(this.productOrderDetails[productId], item => item[type === 'reimbursement' ? 'shipReimbursementQty' : 'shipFollowUpQty'])
    },
    async loadOfficeOrderDetails() {
      this.loading = true

      const [res, err] = await this.request(`/api/v1/orders/-actions/get-reimbursement-products`, {
        params: {
          office_id: this.form.office.id
        }
      })

      if (!err) {
        this.products = res
        this.productOrderDetails = Object.fromEntries(this.products.map(product => ([product.product_id, []])))
        this.productOrderDetailsVisible = Object.fromEntries(this.products.map(product => ([product.product_id, false])))
      }

      this.loading = false
    },
    async loadProductOrderDetails(productId) {
      this.loading = true

      const [res, err] = await this.request(`/api/v1/order-detail-bonuses`, {
        params: {
          'filter[origin_office_id]': this.form.office.id,
          'filter[product_id]': productId,
          'filter[has_reimbursement_or_follow_up]': true,
          'include': 'order',
          'fields[orders]': 'createdAt'
        }
      })

      if (!err) {
        this.productOrderDetailsVisible[productId] = true
        this.productOrderDetails[productId] = res.data.map(item => {
          const order = this.getSingleIncluded(res, item.relationships.order.data.id)

          return {
            id: item.id,
            code: `${item.attributes.order_origin_code}/${item.attributes.order_destination_code}`,
            createdAt: order.attributes.createdAt,
            reimbursementQty: item.attributes.reimbursement_remaining_qty + item.attributes.reimbursement_packed,
            shipReimbursementQty: null,
            originalShipReimbursementQty: null,
            followUpQty: item.attributes.free_follow_up_remaining_qty + item.attributes.free_follow_up_packed,
            shipFollowUpQty: null,
            originalShipFollowUpQty: null,
          }
        })
      }

      this.loading = false
    },
    onChangeOrderDetailQty(productId, index, type) {
      const max = this.productOrderDetails[productId][index][type === 'reimbursement' ? 'reimbursementQty' : 'followUpQty']
      const input = Number(this.productOrderDetails[productId][index][type === 'reimbursement' ? 'shipReimbursementQty' : 'shipFollowUpQty'].replace(/\D/gi, ''))
      const originalInput = Number(this.productOrderDetails[productId][index][type === 'reimbursement' ? 'originalShipReimbursementQty' : 'originalShipFollowUpQty'])

      if (input > max) {
        this.productOrderDetails[productId][index][type === 'reimbursement' ? 'shipReimbursementQty' : 'shipFollowUpQty'] = originalInput
      } else {
        this.productOrderDetails[productId][index][type === 'reimbursement' ? 'originalShipReimbursementQty' : 'originalShipFollowUpQty'] = input
      }
    },
    onOpenOrderDetails(productId) {
      this.productOrderDetailsVisible[productId] = !this.productOrderDetailsVisible[productId]

      if (this.productOrderDetailsVisible[productId] && !this.productOrderDetails[productId].length) {
        this.loadProductOrderDetails(productId)
      }
    },
    async onSave() {
      this.loading = true

      const [, err] = await this.request(`/api/v1/orders/-actions/create-reimbursement-group`, {
        method: 'post',
        data: {
          office_id: this.form.office.id,
          bonuses: Object.values(this.productOrderDetails)
            .flatMap(orderDetails => {
              return orderDetails.map(orderDetail => {
                return {
                  id: orderDetail.id,
                  reimbursement_qty: orderDetail.shipReimbursementQty ? Number(orderDetail.shipReimbursementQty.replace(/\D/gi, '')) : null,
                  follow_up_qty: orderDetail.shipFollowUpQty ? Number(orderDetail.shipFollowUpQty.replace(/\D/gi, '')) : null
                }
              })
            })
            .filter(item => {
              return item.reimbursement_qty > 0 || item.follow_up_qty > 0
            })
        }
      })

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err)
        })
      } else {
        this.createAlert({
          status: 'success',
          data: 'Pengeluaran grup berhasil dibuat'
        })

        this.$router.push({ name: 'gudang.reimbursement-group.index' })
      }

      this.loading = false
    }
  }
}
</script>